import { createApp, } from 'vue'
import './style/main.css'
import './style/utils.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import App from './ui/App.vue'
import { initGlobalApp } from './State.js'

import { createRouter, createWebHistory, } from 'vue-router'
import { SentryWrapper } from './Common/SentryWrapper.js'

import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css';

import Tracker from '@openreplay/tracker';

// Note: we load some components up-front and async load others
import HomeView from './ui/HomeView.vue'
import ProjectView from './ui/ProjectView.vue'
import SignInView from './ui/SignInView.vue'
import UserProfileView from './ui/AccountSettingsView.vue'

import HouseHomeView from './ui/HouseHomeView.vue'
const BuildHouseView = () => import('./ui/BuildHouseView.vue');
const HouseResultsView = () => import('./ui/HouseResultsView.vue');
const HouseResultsPdfReport = () => import('./ui/HouseResultsPdfReport.vue');
const SystemResultsPdfReport = () => import('./ui/SystemResultsPdfReport.vue');
const WallsView = () => import('./ui/WallsView.vue');
const WindowsView = () => import('./ui/WindowsView.vue');
const DoorsView = () => import('./ui/DoorsView.vue');
const SkylightsView = () => import('./ui/SkylightsView.vue');
const ExternalShadingsView = () => import('./ui/ExternalShadingsView.vue');
const InternalShadingsView = () => import('./ui/InternalShadingsView.vue');
const BufferSpacesView = () => import('./ui/BufferSpacesView.vue');
const ImportView = () => import('./ui/ImportView.vue');
const PdfReportView = () => import('./ui/PdfReportView.vue');
const AssistantView = () => import('./Assistant/AssistantView.vue');

import BuildingHomeView from './ui/BuildingHomeView.vue'
const BuildingAndEnvView = () => import('./ui/BuildingAndEnvView.vue');
const SystemsView = () => import('./ui/SystemsView.vue');
const SpacesView = () => import('./ui/SpacesView.vue');
const SchedulesView = () => import('./ui/SchedulesView.vue');
const BuildingResultsView = () => import('./ui/BuildingResultsView.vue');
const ProjectSettingsView = () => import('./ui/ProjectSettingsView.vue');

// Firebase Setup:
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

console.log(`Starting app, in mode: ${import.meta.env.MODE}`);

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBkvN-t-cop25ALRWlW454tHQuJhMKT52Q",
  //authDomain: "buildingcalc.firebaseapp.com",
  authDomain: "app.heatwise-hvac.com",
  projectId: "buildingcalc",
  storageBucket: "buildingcalc.firebasestorage.app",
  messagingSenderId: "815475876429",
  appId: "1:815475876429:web:cbfba3ce60e6d8807bf204",
  measurementId: "G-WTW9LP6FZ4"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// OpenReplay Setup:
const tracker = new Tracker({
  projectKey: "tNYwTZk4biWSIOouGaZs",  
  // Make sure we can see input values, for debugging/support
  obscureTextEmails: false,
  obscureTextNumbers: false,
  obscureInputEmails: false,
  obscureInputNumbers: false,
  obscureInputDates: false,
  defaultInputMode: 0,
});
// If we aren't on localhost, start the tracker
if (window.location.hostname !== 'localhost') {
  tracker.start()
}

const routes = [
  {
    path: '/', name: 'home', component: HomeView,
  },
  {
    path: '/signin', name: 'signin', component: SignInView,
    props: {signIn: true},
  },
  {
    path: '/signup', name: 'signup', component: SignInView,
    props: {signIn: false},
  },
  {
    path: '/house/:id', component: ProjectView,
    name: 'house-project',
    children: [
      {path: '', name: 'house', component: HouseHomeView,},
      {path: 'build', name: 'build', component: BuildHouseView,},
      {path: 'results', name: 'results', component: HouseResultsView,},
      {path: 'walls', name: 'walls', component: WallsView, props: {isRoof: false}},
      {path: 'roofs', name: 'roofs', component: WallsView, props: {isRoof: true}},
      {path: 'windows', name: 'windows', component: WindowsView,},
      {path: 'doors', name: 'doors', component: DoorsView,},
      {path: 'skylights', name: 'skylights', component: SkylightsView,},
      {path: 'externalshadings', name: 'externalshadings', component: ExternalShadingsView,},
      {path: 'internalshadings', name: 'internalshadings', component: InternalShadingsView,},
      {path: 'bufferspaces', name: 'bufferspaces', component: BufferSpacesView,},
      {path: 'import', name: 'import', component: ImportView,},
      {path: 'settings', name: 'settings', component: ProjectSettingsView},
      {path: 'assistant', name: 'assistant', component: AssistantView},
    ]
  },
  {
    path: '/building/:id', component: ProjectView,
    name: 'building-project',
    // Note: 'name' must be unique across all routes, even for nested routes
    children: [
      {path: '', name: 'building', component: BuildingHomeView,},
      {path: 'location', name: 'location', component: BuildingAndEnvView,},
      {path: 'systems', name: 'systems', component: SystemsView},
      {path: 'spaces', name: 'spaces', component: SpacesView},
      {path: 'results', name: 'building-results', component: BuildingResultsView},
      {path: 'schedules', name: 'schedules', component: SchedulesView},
      {path: 'walls', name: 'building-walls', component: WallsView, props: {isRoof: false}},
      {path: 'roofs', name: 'building-roofs', component: WallsView, props: {isRoof: true}},
      {path: 'windows', name: 'building-windows', component: WindowsView,},
      {path: 'doors', name: 'building-doors', component: DoorsView,},
      {path: 'skylights', name: 'building-skylights', component: SkylightsView,},
      {path: 'externalshadings', name: 'building-externalshadings', component: ExternalShadingsView,},
      {path: 'internalshadings', name: 'building-internalshadings', component: InternalShadingsView,},
      {path: 'bufferspaces', name: 'building-bufferspaces', component: BufferSpacesView,},
      {path: 'import', name: 'building-import', component: ImportView,},
      {path: 'settings', name: 'building-settings', component: ProjectSettingsView},
      {path: 'assistant', name: 'building-assistant', component: AssistantView},
    ]
  },
  {
    path: '/reports', component: PdfReportView,
    name: 'reports',
    children: [
      {path: 'house-results-pdf/:id', name: 'house-results-pdf', component: HouseResultsPdfReport,},
      {path: 'system-results-pdf/:id', name: 'system-results-pdf', component: SystemResultsPdfReport,},
    ],
  },
  {
    path: '/psychrometrics', name: 'psychrometrics', component: () => import('./ui/PsychrometricsCalculatorView.vue'),
  },
  {
    path: '/affinity-laws', name: 'affinity-laws', component: () => import('./ui/AffinityLawsCalculatorView.vue'),
  },
  {
    path: '/hydronics-calculator', name: 'hydronics-calculator', component: () => import('./ui/HydronicsCalculatorView.vue'),
  },
  {
    path: '/pipe-head-loss', name: 'pipe-head-loss', component: () => import('./ui/PipeHeadLossCalculatorView.vue'),
  },
  {
    path: '/ductulator', name: 'ductulator', component: () => import('./ui/DuctulatorCalculatorView.vue'),
  },
  {
    path: '/duct-pressure-loss', name: 'duct-pressure-loss', component: () => import('./ui/DuctPressureLossCalculatorView.vue'),
  },
  {
    path: '/solar-calculator', name: 'solar-calculator', component: () => import('./ui/SolarCalculatorView.vue'),
  },
  {
    path: '/account', name: 'account', component: UserProfileView,
  },
  {
    path: '/license-admin', name: 'license-admin', component: () => import('./ui/LicenseAdminView.vue'),
  },
  {
    path: '/admin-console', name: 'admin-console', component: () => import('./ui/AdminConsole.vue'),
  },
  {
    path: '/auth-action', name: 'FirebaseAction', component: () => import('./ui/FirebaseActionHandler.vue')
  },
  // Catch all unmatched routes
  { path: '/:pathMatch(.*)*', redirect: '/' } // or show NotFound
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

const app = createApp(App)

SentryWrapper.init(app);

app.use(router)
app.use(ToastPlugin)
// app.component(VueFeather.name, VueFeather)

let builderApp = initGlobalApp(firebaseApp, router,
  app.config.globalProperties.$toast);
builderApp.setOpenReplayTracker(tracker);
builderApp.run();

let curErrorHandler = app.config.errorHandler;
if (!curErrorHandler) {
  curErrorHandler = (err, instance, info) => {
  }
}
app.config.errorHandler = (err, instance, info) => {
  builderApp.onGlobalError(err, instance, info);
  return curErrorHandler(err, instance, info);
}

// Catch stack overflows that bypass Vue's error handler (e.g. during reactive
// dependency traversal). Access only non-reactive, string-safe values here to
// avoid triggering another overflow while handling the first one.
window.addEventListener('error', (event) => {
  if (event.error instanceof RangeError &&
      event.error.message.includes('call stack')) {
    try {
      const proj = builderApp.proj();
      SentryWrapper.captureException(event.error, {
        source: 'window-error-listener',
        route: window.location.pathname,
        projId: proj?.id ?? null,
        projType: proj?.constructor?.name ?? null,
        projName: proj?.name ?? null,
      });
    } catch (_) {
      // Never let the handler itself throw
    }
  }
});

// Unregister any leftover service workers
// Note - only need to do this temporarily until all users have the new version
// of the app (without the service worker).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      console.log('Unregistering service worker');
      registration.unregister().then((success) => {
        if (success) {
          console.log('Service worker unregistered');
        }
      });
    }
  });
}

app.mount('#app')
